export default "/_assets/cat.077055c4.svg"